import '../custom.css';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import logo from '../components/Images/logo.png';
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";



export default function Login ({ setToken }) {
    const [loginErrorMessage, setLoginErrorMessage] = useState("");
    const [loginStatusCode, setLoginStatusCode] = useState();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const callbackUrl = searchParams.get("callbackurl");
    const jwtToken = searchParams.get("token");

    useEffect(() => {
        if (jwtToken !== null && callbackUrl !== null) {
            console.log("Redirecting to callback URL with token ", callbackUrl);
            window.location.href = decodeURIComponent(callbackUrl) + "?token=" + jwtToken;

        }
        else if (callbackUrl !== null) {
            loginCallback();
        }

    }, [jwtToken]);

    console.log(callbackUrl);

    const dashboardUrl =
        typeof window !== "undefined"
            ? `${window.location.origin.replace("free.", "")}/dashboard`
            : "/dashboard";

    function loginCallback() {
        let fetchUrl = "api/logincallback";
        fetch(fetchUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ callbackUrl })
        })
            .then(data => {
                if (data.status != 200) {
                    data.json()
                        .then((error) => {
                            setLoginStatusCode(data.status)
                            setLoginErrorMessage(error.errors)

                        })

                }
                else {
                    data.json()
                        .then((data) => {
                            if (callbackUrl !== null) {


                                window.location.href = callbackUrl + "?token=" + data.token;

                            }
                            else {
                                setToken(data);
                            }
                        })
                }




            })


    }



    return (

        <Box
            mt={2}
            sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
        >
            <div className="login-wrapper">
                <Card sx={{ maxWidth: 700, textAlign: "center", mx: "auto" }}>
                    <CardMedia
                        component="img"
                        alt="logo"
                        height="140"
                        className="loginCard"
                        image={logo}
                    />

                    <CardContent>
                        <Box sx={{ textAlign: "center", width: "100%" }}>
                            {!!loginStatusCode && loginStatusCode !== 200 && (
                                <Typography color="error" variant="body2" gutterBottom>
                                    {loginStatusCode}: {loginErrorMessage}
                                </Typography>
                            )}

                            <Typography variant="h5" gutterBottom>
                                Log in to Command Center
                            </Typography>

                            <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
                                Continue in your dashboard to access Command Center.
                            </Typography>

                            <Button
                                variant="contained"
                                size="large"
                                endIcon={<ArrowForwardIcon />}
                                onClick={() => (window.location.href = dashboardUrl)}
                                sx={{
                                    borderRadius: 2,
                                    px: 3,
                                    py: 1.2,
                                    textTransform: "none",
                                    fontWeight: 700,
                                }}
                            >
                                Go to Dashboard
                            </Button>

                            <Typography variant="caption" sx={{ display: "block", mt: 1.5, color: "text.secondary" }}>
                                {dashboardUrl}
                            </Typography>
                        </Box>
                    </CardContent>
                </Card>
            </div>
        </Box>

         


        
    )
}

Login.propTypes = {
    setToken: PropTypes.func.isRequired
};